import React, { useCallback, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FeedbackPage from './FeedbackPage';
import { updateStageFeedback } from '../../functions/stageReport';
import { selectAdminToken } from '../../admin/sessionSlice';

export default function DayFeedback() {
  const navigate = useNavigate();
  const location = useLocation();
  const adminToken = useSelector(selectAdminToken);
  const { user } = useSelector((state) => state.auth);

  const state = location.state || {};
  const dayNumber = useMemo(() => {
    const n = Number(state.dayNumber);
    return Number.isFinite(n) ? n : null;
  }, [state.dayNumber]);
  const stageId = useMemo(() => {
    const n = Number(state.stageId);
    return Number.isFinite(n) ? n : null;
  }, [state.stageId]);

  const [saving, setSaving] = useState(false);

  const onSelect = useCallback(
    async (label) => {
      if (saving) return;
      if (!adminToken || !user?.userId || !dayNumber) {
        navigate('/main', { replace: true });
        return;
      }
      setSaving(true);
      try {
        await updateStageFeedback({
          token: adminToken,
          userId: user.userId,
          dayNumber,
          feedback: label,
          stageId,
        });
      } catch (e) {
        // If save fails, still return user to main (don’t block flow).
        console.warn('updateStageFeedback failed:', e?.message || e);
      } finally {
        navigate('/main', { replace: true });
      }
    },
    [adminToken, user?.userId, dayNumber, stageId, navigate, saving]
  );

  return (
    <div style={{ opacity: saving ? 0.98 : 1, pointerEvents: saving ? 'none' : 'auto' }}>
      <FeedbackPage onSelect={onSelect} />
    </div>
  );
}

